import { jsPDF } from 'jspdf';
import html2canvas from 'html2canvas';
import {
  StudyCertificatePDFData,
  createStudyCertificateHTML,
} from './study-certificate-html-template';

export type { StudyCertificatePDFData } from './study-certificate-html-template';

// ─── PDF generator ────────────────────────────────────────────────────────────

export async function generateStudyCertificatePDF(
  data: StudyCertificatePDFData,
): Promise<void> {
  const html = createStudyCertificateHTML(data);

  const iframe = document.createElement('iframe');
  iframe.style.cssText =
    'position:fixed;top:0;left:0;width:794px;height:1123px;border:none;visibility:hidden;z-index:-9999;';
  document.body.appendChild(iframe);

  const iframeDoc = iframe.contentDocument!;
  iframeDoc.open();
  iframeDoc.write(html);
  iframeDoc.close();

  try {
    await new Promise<void>((resolve) => {
      if (iframe.contentDocument?.readyState === 'complete') {
        resolve();
      } else {
        iframe.onload = () => resolve();
      }
    });

    await iframe.contentDocument?.fonts?.ready;

    const images = Array.from(iframeDoc.querySelectorAll('img'));
    await Promise.all(
      images.map((img) =>
        img.complete
          ? Promise.resolve()
          : new Promise<void>((resolve) => {
              img.onload = () => resolve();
              img.onerror = () => resolve();
            }),
      ),
    );

    const pageEl = iframeDoc.querySelector('.page') as HTMLElement;

    const canvas = await html2canvas(pageEl, {
      scale: 2,
      useCORS: true,
      allowTaint: false,
      backgroundColor: '#ffffff',
      width: 794,
      height: 1123,
      windowWidth: 794,
      windowHeight: 1123,
      logging: false,
    });

    const pdf = new jsPDF({
      orientation: 'portrait',
      unit: 'mm',
      format: 'a4',
    });

    const imgData = canvas.toDataURL('image/jpeg', 0.97);
    pdf.addImage(
      imgData,
      'JPEG',
      0,
      0,
      pdf.internal.pageSize.getWidth(),
      pdf.internal.pageSize.getHeight(),
    );
    pdf.save(`אישור_לימודים_${data.studentName}.pdf`);
  } finally {
    document.body.removeChild(iframe);
  }
}
